module.exports = __webpack_public_path__ + "img/lily.1c7e33aa.jpg";